import { render, staticRenderFns } from "./bookingsByPlacePage.vue?vue&type=template&id=b8b49442&scoped=true"
import script from "./bookingsByPlacePage.vue?vue&type=script&lang=ts"
export * from "./bookingsByPlacePage.vue?vue&type=script&lang=ts"
import style0 from "./bookingsByPlacePage.vue?vue&type=style&index=0&id=b8b49442&prod&lang=css"
import style1 from "./bookingsByPlacePage.vue?vue&type=style&index=1&id=b8b49442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b49442",
  null
  
)

export default component.exports